export enum HTTP_CODES {
    UnknownError = 0,
    BadRequest = 400,
    Unauthorized = 401,
    InternalServerError = 500
}